/** @jsx jsx */
import { jsx, Grid, Link } from 'theme-ui';
import Mean from './mean';
import TimeReport from '../TimeReport';
/* 
import LogoLink from "components/logo-link"; */

export default function Footer(props) {
	return (
		<footer className="psf m0 b0 l0 z8 c12 bgb">
			<div className="x xw c12 xjb bt1">
				<Mean>
					<TimeReport />
				</Mean>
			</div>
			<div className="grad-effect" />
		</footer>
	);
}
